/* Levi Tzeiger editorial components (draft). No dependencies. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initVideos(root) {
    var boxes = root.querySelectorAll('[data-lt-video]:not([data-lt-ready])');
    Array.prototype.forEach.call(boxes, function (box) {
      box.setAttribute('data-lt-ready', '');
      var video = box.querySelector('video');
      var btn = box.querySelector('[data-lt-toggle]');
      if (!video) return;
      var userPaused = reduce;
      function setState(playing) {
        if (btn) {
          btn.setAttribute('aria-pressed', playing ? 'true' : 'false');
          btn.setAttribute('aria-label', playing ? btn.getAttribute('data-label-pause') : btn.getAttribute('data-label-play'));
        }
      }
      function play() {
        var p = video.play();
        if (p && p.catch) p.catch(function () { setState(false); });
      }
      video.addEventListener('play', function () { setState(true); });
      video.addEventListener('pause', function () { setState(false); });
      setState(false);
      if (btn) {
        btn.addEventListener('click', function () {
          if (video.paused) { userPaused = false; play(); } else { userPaused = true; video.pause(); }
        });
      }
      if (!('IntersectionObserver' in window)) { if (!userPaused) play(); return; }
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { if (!userPaused) play(); } else if (!video.paused) { video.pause(); }
        });
      }, { threshold: 0.35 }).observe(box);
    });
  }

  function blocksSticky(el) {
    var node = el.parentElement;
    while (node && node !== document.body && node !== document.documentElement) {
      var cs = getComputedStyle(node);
      if (/(hidden|auto|scroll)/.test(cs.overflowX + ' ' + cs.overflowY)) {
        /* Some themes scroll a full-height page wrapper instead of the window; sticky works there. */
        if (/(auto|scroll)/.test(cs.overflowY) && node.clientHeight >= window.innerHeight * 0.9) return false;
        return true;
      }
      node = node.parentElement;
    }
    return false;
  }

  function headerOffset() {
    var hc = document.querySelector('header-component');
    if (hc) {
      return hc.getAttribute('sticky') === 'always' ? Math.round(hc.getBoundingClientRect().height) : 0;
    }
    return 0;
  }

  /* Mobile (below 990px): the text stays pinned on top, the photos scroll beneath it and fade in and out. */
  function initMobileStory(story, frames, steps) {
    var panel = story.querySelector('.lt-story__steps');
    if (!panel) return;
    var ticking = false, lastW = 0;
    story.style.setProperty('--lt-sticky-top', headerOffset() + 'px');
    story.classList.add('lt-story--mobile');
    function activate(i) {
      for (var k = 0; k < steps.length; k++) steps[k].classList.toggle('is-active', k === i);
    }
    function size() {
      lastW = window.innerWidth;
      var room = window.innerHeight - headerOffset() - panel.offsetHeight - 28;
      var h = Math.max(240, Math.min(window.innerWidth * 1.2, room));
      story.style.setProperty('--lt-story-frame-h', Math.round(h) + 'px');
    }
    function update() {
      ticking = false;
      var zoneTop = Math.max(panel.getBoundingClientRect().bottom, 0);
      var zoneH = Math.max(window.innerHeight - zoneTop, 1);
      var focus = zoneTop + zoneH * 0.45;
      var range = zoneH * 0.75;
      var best = 0, bestD = Infinity;
      for (var k = 0; k < frames.length; k++) {
        var r = frames[k].getBoundingClientRect();
        var d = Math.abs(r.top + r.height / 2 - focus);
        var o = Math.max(0, Math.min(1, 1 - d / range));
        o = o * o * (3 - 2 * o);
        frames[k].style.opacity = o.toFixed(3);
        frames[k].style.transform = 'scale(' + (0.96 + 0.04 * o).toFixed(4) + ')';
        if (d < bestD) { bestD = d; best = k; }
      }
      activate(best);
    }
    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('resize', function () { if (window.innerWidth !== lastW) size(); onScroll(); });
    size();
    update();
  }

  function initStories(root) {
    var stories = root.querySelectorAll('[data-lt-story]:not([data-lt-ready])');
    Array.prototype.forEach.call(stories, function (story) {
      story.setAttribute('data-lt-ready', '');
      if (reduce) return;
      if (!('IntersectionObserver' in window)) return;
      if (!(window.CSS && CSS.supports && CSS.supports('position', 'sticky'))) return;
      if (blocksSticky(story)) { story.setAttribute('data-lt-fallback', 'overflow'); return; }
      var frames = story.querySelectorAll('.lt-story__frame');
      var steps = story.querySelectorAll('.lt-story__step');
      var dots = story.querySelectorAll('.lt-story__progress span');
      if (!frames.length || frames.length !== steps.length) return;
      if (!window.matchMedia('(min-width: 990px)').matches) { initMobileStory(story, frames, steps); return; }
      story.style.setProperty('--lt-sticky-top', headerOffset() + 'px');
      story.classList.add('lt-story--enhanced');
      function activate(i) {
        for (var k = 0; k < steps.length; k++) {
          var on = k === i;
          frames[k].classList.toggle('is-active', on);
          steps[k].classList.toggle('is-active', on);
          if (dots[k]) dots[k].classList.toggle('is-active', on);
        }
      }
      activate(0);
      var desktop = window.matchMedia('(min-width: 990px)').matches;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) activate(Array.prototype.indexOf.call(steps, e.target));
        });
      }, { rootMargin: desktop ? '-45% 0px -45% 0px' : '-62% 0px -22% 0px' });
      Array.prototype.forEach.call(steps, function (s) { io.observe(s); });
    });
  }

  /* Catalog filter: hides cards only; state kept in the URL hash so Back returns to the same view. */
  function initCatalogs(root) {
    var cats = root.querySelectorAll('[data-lt-catalog]:not([data-lt-ready])');
    Array.prototype.forEach.call(cats, function (cat) {
      cat.setAttribute('data-lt-ready', '');
      var bar = cat.querySelector('[data-lt-filter]');
      if (!bar) return;
      bar.hidden = false;
      var items = cat.querySelectorAll('.lt-cat__item');
      var chips = bar.querySelectorAll('.lt-chip');
      var count = bar.querySelector('.lt-filter__count');
      var reset = bar.querySelector('[data-reset]');
      var empty = cat.querySelector('[data-empty]');
      var state = { world: 'all', type: 'all' };
      var m = /lt=([a-z]+)\.([a-z]+)/.exec(location.hash || '');
      if (m) {
        if (bar.querySelector('[data-key="world"][data-value="' + m[1] + '"]')) state.world = m[1];
        if (bar.querySelector('[data-key="type"][data-value="' + m[2] + '"]')) state.type = m[2];
      }
      function apply(push) {
        var n = 0;
        Array.prototype.forEach.call(items, function (it) {
          var ok = (state.world === 'all' || it.getAttribute('data-world') === state.world) &&
                   (state.type === 'all' || it.getAttribute('data-type') === state.type);
          it.hidden = !ok;
          if (ok) n++;
        });
        Array.prototype.forEach.call(chips, function (c) {
          c.setAttribute('aria-pressed', state[c.getAttribute('data-key')] === c.getAttribute('data-value') ? 'true' : 'false');
        });
        if (count) count.textContent = n === 1 ? bar.getAttribute('data-count-one') : bar.getAttribute('data-count-many').replace('[n]', n);
        if (empty) empty.hidden = n !== 0;
        var isDefault = state.world === 'all' && state.type === 'all';
        if (reset) reset.hidden = isDefault;
        if (push && history.replaceState) {
          history.replaceState(null, '', location.pathname + location.search + (isDefault ? '' : '#lt=' + state.world + '.' + state.type));
        }
      }
      Array.prototype.forEach.call(chips, function (c) {
        c.addEventListener('click', function () { state[c.getAttribute('data-key')] = c.getAttribute('data-value'); apply(true); });
      });
      if (reset) reset.addEventListener('click', function () { state.world = 'all'; state.type = 'all'; apply(true); });
      apply(false);
    });
  }

  /* Guides: open the topic named in the link (#ring-size, #care ...). */
  function openTopicFromHash() {
    var id = (location.hash || '').slice(1);
    if (!id || id.indexOf('lt=') === 0) return;
    var el = document.getElementById(id);
    if (el && el.tagName === 'DETAILS') { el.open = true; }
  }

  /* Floating WhatsApp: lift above the sticky add-to-cart bar, and step aside while a buy button
     or a form button sits in the bottom band of the screen, so purchase controls stay uncovered. */
  function initWa() {
    var wa = document.querySelector('[data-lt-wa]');
    if (!wa || wa.hasAttribute('data-lt-ready')) return;
    wa.setAttribute('data-lt-ready', '');
    var ticking = false;
    function update() {
      ticking = false;
      var lift = 0;
      var bar = document.querySelector('.sticky-add-to-cart__bar');
      if (bar) {
        var r = bar.getBoundingClientRect();
        var cs = getComputedStyle(bar);
        if (r.height > 0 && r.top < window.innerHeight - 2 && r.bottom > 0 && cs.visibility !== 'hidden' && parseFloat(cs.opacity) > 0.05) {
          lift = Math.round(window.innerHeight - r.top) + 6;
        }
      }
      wa.style.setProperty('--lt-wa-lift', lift + 'px');
    }
    function queue() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', queue, { passive: true });
    document.addEventListener('scroll', queue, { passive: true, capture: true });
    window.addEventListener('resize', queue);
    update();
    setTimeout(update, 900);
    /* The sticky bar slides in with a transition, so keep the lift in step while it exists. */
    if (document.querySelector('.sticky-add-to-cart__bar')) setInterval(update, 400);
    if ('IntersectionObserver' in window) {
      var targets = document.querySelectorAll('.product-form-buttons, .accelerated-checkout-block, .lt-form button[type="submit"], .shopify-payment-button');
      if (targets.length) {
        var band = Math.max(0, window.innerHeight - 120);
        var inBand = new Set();
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) inBand.add(e.target); else inBand.delete(e.target); });
          if (inBand.size) wa.setAttribute('data-hidden', ''); else wa.removeAttribute('data-hidden');
        }, { rootMargin: '-' + band + 'px 0px 0px 0px' });
        Array.prototype.forEach.call(targets, function (t) { io.observe(t); });
      }
    }
  }

  function init(root) {
    root = root || document;
    initVideos(root); initStories(root); initCatalogs(root); initWa();
    openTopicFromHash();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  window.addEventListener('hashchange', openTopicFromHash);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* Hebrew labels for the new header menu (draft). Links are already localized by Shopify. */
(function () {
  var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
  if (lang.indexOf('he') !== 0) return;
  var map = { 'jewelry': 'תכשיטים', 'studio work': 'עבודות הסטודיו', 'personal design': 'עיצוב אישי', 'the studio': 'הסטודיו' };
  function fix(scope) {
    var links = (scope || document).querySelectorAll('header-component a, #header-component a, [id^="HeaderDrawer"] a, a[id^="HeaderDrawer"], .menu-drawer a');
    Array.prototype.forEach.call(links, function (a) {
      var walker = document.createTreeWalker(a, NodeFilter.SHOW_TEXT);
      var n;
      while ((n = walker.nextNode())) {
        var raw = n.nodeValue.trim();
        var he = map[raw.toLowerCase()];
        if (he) n.nodeValue = n.nodeValue.replace(raw, he);
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { fix(); });
  else fix();
  document.addEventListener('shopify:section:load', function (e) { fix(e.target); });
  /* The header can re-render its menu (overflow handling, sticky states), so keep labels in Hebrew. */
  if ('MutationObserver' in window) {
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; fix(); });
    }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  }
})();
